import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { User, UserInfoGraphic } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoGraphics',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore<ShiftCMSState & { us: UsersState }>();

const infographics = computed<UserInfoGraphic[]>(
  () => store.state.us.userInfoGraphics,
);

const headers = [
  { title: 'Infographic', key: 'infographic.title' },
  { title: 'Options', key: 'options' },
];

function deleteUserInfoGraphic(id: number) {
  store.dispatch(UsersActions.DeleteUserInfoGraphic, {
    id,
    userId: props.user.id,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Infographics")
        ])),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: infographics.value,
        itemsPerPage: "10",
        hover: ""
      }, {
        "item.options": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            density: "compact",
            icon: "mdi-delete-outline",
            onClick: ($event: any) => (deleteUserInfoGraphic(item.id))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})